import * as actions from '../Actions/Modes';

export const modesReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.GET_MODES_DATA_REQUESTED:
            return {...state, isLoading: true};
        case actions.GET_MODES_DATA_DONE:
            return {...state, isLoading: false, modes: action.payload};
        case actions.GET_MODES_DATA_FAILED:
            return {...state, isLoading: false, isError: true, error: action.payload};
        default:
            return state;
    }
    };